'use client';

import { useEffect } from 'react';
import { pushRecentlyViewed, type StoredProduct } from '@/lib/wishlist';
import { trackViewItem, parsePrice } from '@/lib/analytics';

// Records a visit into the localStorage "recently viewed" buffer when the
// product page mounts, and fires the GA4 view_item event. Renders nothing.
export function TrackProductView({
  product,
  brand,
  category,
  category2,
}: {
  product:   StoredProduct;
  brand?:    string;
  category?: string;   // gender bucket: For Her | For Him | Unisex
  category2?: string;  // fragrance family
}) {
  useEffect(() => {
    pushRecentlyViewed(product);
    trackViewItem({
      item_id:        product.id,
      item_name:      product.name,
      item_brand:     brand,
      item_category:  category,
      item_category2: category2,
      price:          parsePrice(product.price),
    });
  }, [product.id, product.name, product.price, product.image, brand, category, category2]);
  return null;
}
